import { ref } from 'vue';
import { TemplateCategory } from '@/entities/template/category/model';
import { Template } from '@/entities/template/model';

export const templateCategory = ref<TemplateCategory[]>([]);
export const templates = ref<Template[]>([]);
